<template>
    <div class="notification">
        <div class="notification__bell" @click="triggerNotifications">
            <i class="notification__bell--icon fa fa-bell-o"></i>
            
            <div v-if="notifications.counter" class="notification__bell--counter">
                {{notifications.counter}}
            </div>
        </div>
            
        <div v-if="notifications.active" 
            class="notification__overlay" 
            @click="triggerNotifications"
        ></div>
        
        <div class="notification__dropdown"
            :style="{
                display: notifications.active ? 'block' : 'none'
            }">
            <div class="dropdown__header">
                <div class="dropdown__header--title">
                    Notificări {{ notifications.counter?`(${notifications.counter})`:null }}
                </div>
            </div>
            
            <div class="dropdown__body">
                
                <div v-if="!notifications.counter">
                    <div class="info__no-exists">
                        Nu există notificări noi
                    </div>
                </div>
                
                <NotificationItem
                    v-for="(notification, i) in notifications.new"
                    :key="i"
                    :type="notification.type"
                    :title="getDemoText(notification.title)"
                    :text="getDemoText(notification.message)"
                    :time="notification.created_at"
                    :imageUrl="notification.image_url"
                    :initiator="notification.initiator"
                    :dropdown="true"
                    :date="notification.created_at"
                    @exit="triggerNotifications"
                />
                
                <div v-if="notifications.counter > 3" class="info" @click="goToNotificationsPage">
                    <div class="info__text">
                        +{{notifications.counter-2}} notificări noi
                    </div>
                    <div class="info__subtext">
                        Mai aveți încă 
                        {{ 
                            notifications.counter-2 == 1 ? 
                            'o notificare necitită' : 
                            notifications.counter-2+' notificări necitite'
                        }}
                    </div>
                </div>
            </div>
            
            <div class="dropdown__footer">
                <div class="dropdown__footer--text" @click="goToNotificationsPage">
                    Vezi toate notificările
                </div> 
            </div>  
        </div>
    </div>
</template>

<script>
import NotificationItem from '@/pages/NotificationsPage/components/NotificationItem';
import { mapActions, mapGetters } from 'vuex';
import * as moment from 'moment';

export default {
    components: {
        NotificationItem
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            notifications: 'layout/notifications'
        })
    },
    mounted() {
        this.fetchNewestNotifications();
    },
    methods: {
        ...mapActions({
            fetchNewestNotifications: 'layout/fetchNewestNotifications',
            readNotifications: 'layout/readNotifications',
            fetchNotifications: "notification/fetchNotifications",
        }),
        getDemoText(text) {
            if(text.length <= 30)
                return text;
            return text.substr(0, 30)+' ...';
        },
        triggerNotifications() {
            this.$store.state.layout.notifications.active = !this.notifications.active;

            if(this.notifications.active) {
                if(window.innerWidth < 576)
                    document.body.style.overflow = 'hidden';
                
            } else {
                document.body.style.overflow = null;
                
                if(this.notifications.new.length) {
                    var notificationsIds = [];
                    this.notifications.new.forEach((notification, index) => {
                        notificationsIds.push(notification.id);
                    });
                    this.$store.state.layout.notifications.new = [];
                    this.$store.state.layout.notifications.counter = 0;
                    this.readNotifications({
                        ids: notificationsIds,
                        next: true
                    });
                }
            }
        },
        goToNotificationsPage() {
            this.triggerNotifications();
            this.$router.push('/notifications');
            
            this.fetchNotifications(1);
        }
    }
}
</script>

<style lang="scss" scoped>
    .notification {
        
        &__bell {
            position: relative;
            display: inline-block;
            
            &--icon {
                font-size: 30px;
                color: $color-gray;
                transition: 0.3s;
                &:hover {
                    color: $color-primary;
                }
            }
            
            &--counter {
                position: absolute;
                top: -6px;
                left: 20px;
                display: flex;
                justify-content: center;
                height: 18px;
                width: 18px;
                animation: pulse 3s ease-out;
                animation-iteration-count: infinite;
                font-family: 'Roboto', sans-serif;
                font-style: normal;
                font-size: 14px;
                font-weight: bolder;
                align-items: center;
                text-align: center;
                color: #FFFFFF;
                background: $color-secondary;
                border-radius: 50%;
            }
        }
        
        &__dropdown {
            position: absolute;
            top: 70px;
            flex-direction: column;
            background: #FFFFFF;
            box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
            overflow-y: hidden;
            width: 340px;
            left: auto;
            right: 5px;
            z-index: 20;
            
            @include media-breakpoint-down(sm) {
                left: 0;
                right: auto;
                width: 100%;
            }
        }
        
        &__overlay {
            position: fixed;
            background-color: rgba(transparent, 0);
            top: 0;
            left: 0;
            right: 0;
            z-index: 20;
            height: 100%;
            overflow-y: hidden;
            
            @include media-breakpoint-down(sm) {
                // background: rgba(0, 0, 0, 0.1);
                box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
            }
        }
    }
    
    .dropdown {
         
        &__header {
            width: 100%;
            min-height: 40px;
            position: relative;
            background-color: #FFFFFF;
            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
            
            &--title {
                position: absolute;
                top: 50%; 
                left: 10px;
                transform: translate(0,-50%);
                user-select: none;
                font-family: 'DIN Pro', sans-serif;
                font-style: normal;
                font-weight: bold;
                font-size: 20px;
                line-height: 20px;
                color: #373435;
            }
        }
        
        &__body {
            width: 100%;
            min-height: 50px;
            max-height: 350px;
            overflow-y: auto;
            padding: 5px;
            background-color: #FFFFFF;
        }
        
        &__footer {
            min-height: 40px;
            position: relative;
            background-color: #FFFFFF;
            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
            
            &--text {
                position: absolute;
                top: 50%; left: 50%;
                transform: translate(-50%,-50%);
                
                font-family: 'DIN Pro', sans-serif;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 20px;
                display: flex;
                align-items: center;
                color: #3C59A6;
                user-select: none;
                &:hover {
                    text-decoration-line: underline;   
                }
            }
        }
    }
    
    .info {
        width: 100%;
        padding: 5px;
        background-color: #FFFFFF;
        filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.06));
        
        &__text {
            margin: 15px 5px 5px 5px;
            font-family: 'Roboto', sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 19px;
            display: flex;
            align-items: center;
            color: #373435;
            user-select: none;
        }
        
        &__subtext {
            margin: 10px 5px;
            font-family: 'DIN Pro', sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 17px;
            color: rgba(55, 52, 53, 0.75);
            user-select: none;
        }
        
        &__no-exists {
            font-family: 'DIN Pro', sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 17px;
            color: #3C59A6;
            margin-top: 10px;
            margin-left: 5px;
            user-select: none;
        }
    }
    
    @keyframes pulse {
        40% {
            transform: scale3d(1, 1, 1);
        }
        50% {
            transform: scale3d(1.3, 1.3, 1.3);
        }
        55% {
            transform: scale3d(1, 1, 1);
        }
        60% {
            transform: scale3d(1.3, 1.3, 1.3);
        }
        65% {
            transform: scale3d(1, 1, 1);
        }
    }
</style>